import ReflectionCell from './ReflectionCell';
import style from './Legend.scss';
import { QUESTION_GROKKED } from 'edrolo/domains/exams';

const LegendCell = (props) => (
  <ReflectionCell className={style.smallCell} {...props} />
);

export default () => (
  <div className={style.legend}>
    <span className={style.item}>
      <LegendCell grokked={QUESTION_GROKKED.YES} />
      <span className={style.label}>Understands</span>
    </span>
    <span className={style.item}>
      <LegendCell grokked={QUESTION_GROKKED.NO} />
      <span className={style.label}>Needs help</span>
    </span>
    <span className={style.item}>
      <LegendCell grokked={QUESTION_GROKKED.NO_RESPONSE} />
      <span className={style.label}>Not reflected</span>
    </span>
  </div>
);
